import React from 'react';
import Box from './Box';

const dotSize = 1;
const spaceSize = 5;
const ratio = `${(100 * dotSize) / spaceSize}%`;
const STYLE_PROPS = {
  vertical: {
    backgroundImage: `linear-gradient(black ${ratio}, rgba(255,255,255,0) 0%)`,
    backgroundPosition: 'right',
    backgroundSize: `${dotSize}px ${spaceSize}px`,
    backgroundRepeat: 'repeat-y',
    width: '1px'
  },
  horizontal: {
    backgroundImage: `linear-gradient(to right, black ${ratio}, rgba(255,255,255,0) 0%)`,
    backgroundPosition: 'bottom',
    backgroundSize: `${spaceSize}px ${dotSize}px`,
    backgroundRepeat: 'repeat-x',
    height: '1px'
  }
};

export default class DottedLine extends React.PureComponent {
  render() {
    const { orientation = 'vertical', style = {}, ...props } = this.props;

    return (
      <Box
        {...props}
        style={{
          ...STYLE_PROPS[orientation],
          ...style
        }}
      />
    );
  }
}
